import { Check, Circle, Clock, Truck, PackageCheck, FileText } from "lucide-react";

const STEPS = [
  { key: "OPEN", label: "Open", icon: FileText, desc: "Request logged" },
  { key: "IN PROGRESS", label: "In Progress", icon: Clock, desc: "Sourcing & prep" },
  { key: "DELIVERY", label: "Delivery", icon: Truck, desc: "On the way" },
  { key: "CLOSED", label: "Closed", icon: PackageCheck, desc: "Completed" },
];

export const StatusPipeline = ({ current }) => {
  const idx = STEPS.findIndex((s) => s.key === current);
  return (
    <div
      className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 p-4 sm:p-5 bg-[#121216] border border-white/10 rounded-2xl"
      data-testid="status-pipeline"
    >
      {STEPS.map((step, i) => {
        const active = i === idx;
        const done = i < idx;
        const Icon = done ? Check : step.icon;
        return (
          <div
            key={step.key}
            data-testid={`pipeline-step-${step.key.toLowerCase().replace(" ", "-")}`}
            className={`relative flex items-center gap-3 p-4 rounded-xl border transition-all ${
              active
                ? "bg-amber-500/10 border-amber-500/40 shadow-[0_0_30px_rgba(245,158,11,0.15)]"
                : done
                ? "bg-emerald-500/5 border-emerald-500/20"
                : "bg-white/[0.02] border-white/5"
            }`}
          >
            <div
              className={`shrink-0 w-9 h-9 rounded-lg flex items-center justify-center ${
                active
                  ? "bg-amber-500 text-black"
                  : done
                  ? "bg-emerald-500/20 text-emerald-400"
                  : "bg-white/5 text-slate-500"
              }`}
            >
              <Icon className="w-4 h-4" />
            </div>
            <div className="flex-1 min-w-0">
              <div
                className={`text-xs uppercase tracking-widest font-semibold ${
                  active ? "text-amber-400" : done ? "text-emerald-400" : "text-slate-500"
                }`}
              >
                Step {i + 1}
              </div>
              <div
                className={`font-display text-sm sm:text-base font-bold uppercase ${
                  active ? "text-white" : done ? "text-slate-200" : "text-slate-500"
                }`}
              >
                {step.label}
              </div>
              <div className="text-[11px] text-slate-500 truncate">{step.desc}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default StatusPipeline;
